import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import type { Registry as Services } from '@ember/service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { local } from 'embroider-css-modules';
import type { BudgetForecastVersion } from 'lumen/models';

import styles from './item.module.css';

interface SettingsBudgetForecastVersionHistoryDrawerItemSignature {
  Args: {
    isActive: boolean;
    onSelectVersion: () => void;
    version: BudgetForecastVersion;
  };
}

export default class SettingsBudgetForecastVersionHistoryDrawerItem extends Component<SettingsBudgetForecastVersionHistoryDrawerItemSignature> {
  @service declare intl: Services['intl'];

  get createdByLabel(): string {
    const { createdBy } = this.args.version;

    if (createdBy) {
      return createdBy.name;
    }

    return this.intl.t('general.missing');
  }

  get dateLabel(): string {
    return this.args.version.date.local().format('D MMM YYYY HH:mm');
  }

  <template>
    {{#if @isActive}}
      <div aria-current="true" class={{styles.container}} data-test-item>
        <span
          class={{concat
            "mt-100"
            " "
            (local styles "bullet" "is-small" "is-active")
          }}
          data-test-item-active
          data-test-item-bullet
        ></span>

        <div class="overflow-hidden">
          <p
            class="text-200--regular text-neutral-emphasis"
            data-test-date-label
          >
            {{this.dateLabel}}
          </p>
          <p
            class="text-200--regular text-neutral-subdued truncate"
            data-test-created-by
            title={{this.createdByLabel}}
          >
            {{this.createdByLabel}}
          </p>
        </div>
      </div>
    {{else}}
      <button
        class={{concat
          "button--unstyled"
          " "
          (local styles "container" "is-button")
        }}
        data-test-item
        type="button"
        {{on "click" @onSelectVersion}}
      >
        <span
          class={{concat "mt-100" " " (local styles "bullet" "is-small")}}
          data-test-item-bullet
        ></span>

        <div class="overflow-hidden">
          <p
            class="text-200--regular text-neutral-emphasis"
            data-test-date-label
          >
            {{this.dateLabel}}
          </p>
          <p
            class="text-200--regular text-neutral-subdued truncate"
            data-test-created-by
            title={{this.createdByLabel}}
          >
            {{this.createdByLabel}}
          </p>
        </div>
      </button>
    {{/if}}
  </template>
}
